import React, { useState } from 'react';
import { Wrapper, Prev, Next, Prevtwo, Nexttwo } from './styled';

const Pagination = ({ paged, total, postsPerPage, maxPaged, onPaging }) => {
	//
	const max = maxPaged;
	const pageArray = [];
	let parentPage = Math.floor((paged - 0.1) / 5);

	for (let i = 0; i < 5 && i + 1 + 5 * parentPage <= max; i += 1) {
		pageArray.push(
			<li
				onClick={(e) =>
					i + 1 + 5 * parentPage != Number(paged)
						? onPaging(e.currentTarget.dataset.id)
						: null
				}
				data-id={i + 1 + 5 * parentPage}
				key={i}
				className={
					i + 1 + 5 * parentPage == Number(paged) ? 'active' : 'pageNum'
				}
			>
				<a>{i + 1 + 5 * parentPage}</a>
			</li>
		);
	}

	const [activePage, setActivePage] = useState(1);

	const handlePageClick = (pageNumber) => {
		setActivePage(pageNumber);
	};

	const onPaging_ = (num) => {
		if (paged == maxPaged) {
			return;
		}
		onPaging(num);
	};

	return (
		<Wrapper>
			<div className="pagenum">
				{parseInt(paged) > 5 ? (
					<>
						<Prevtwo onClick={(e) => onPaging(1)} className="button"></Prevtwo>
						<Prev
							className="button"
							onClick={(e) => onPaging((Math.ceil(paged / 5) - 2) * 5 + 1)}
						></Prev>
					</>
				) : (
					<>
						<Prevtwo
							onClick={(e) => onPaging(1)}
							className="button disable"
						></Prevtwo>
						<Prev className="button disable"></Prev>
					</>
				)}
				<div className="page-number">
					<ul>
						{pageArray.length ? pageArray : <li className="active">1</li>}
					</ul>
				</div>
				{(Math.floor((paged - 0.1) / 5) + 1) * 5 < maxPaged ? (
					<>
						<Next
							className="button"
							onClick={(e) => onPaging(Math.ceil(paged / 5) * 5 + 1)}
						></Next>
						<Nexttwo
							onClick={(e) => onPaging_(maxPaged)}
							className="button"
						></Nexttwo>
					</>
				) : (
					<>
						<Next className="button disable"></Next>
						<Nexttwo
							onClick={(e) => onPaging_(maxPaged)}
							className="button disable"
						></Nexttwo>
					</>
				)}
			</div>
		</Wrapper>
	);
};

export default Pagination;
